<template>
  <v-card flat style="background-color: #f0f7ff">
    <v-row no-gutters>
      <v-col
        xs="12"
        sm="12"
        md="6"
        lg="6"
        xl="6"
        class="pt-6 pb-6"
        align-self="center"
      >
        <v-row no-gutters justify="center">
          <v-col cols="10" class="pb-2">
            <div class="text-h5 text-lg-h4 font-weight-bold">
              PEJA (Projeto de Educação de Jovens e Adultos)
            </div>
          </v-col>

          <v-col cols="10" class="pt-6 pb-6">
            <div class="text-lg-h6 font-weight-light">
              O PEJA - Projeto de Educação de Jovens e Adultos é um projeto de
              extensão universitária, vinculado a Pro Reitoria de Extensão
              Universitária e Cultura, desenvolvido em seis campus da Unesp,
              incluindo a Faculdade de Ciências da UNESP Bauru, sendo a
              coordenação local vinculada ao Departamento de Educação.
            </div>
          </v-col>
        </v-row>

        <v-row no-gutters justify="center">
          <v-col cols="10">
            <v-dialog
              v-model="dialog"
              style="z-index: 999999 !important"
              max-width="40%"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  rounded
                  :x-large="
                    $vuetify.breakpoint.lg ||
                    $vuetify.breakpoint.md ||
                    $vuetify.breakpoint.xl
                  "
                  color="orange"
                  style="color: white; font-weight: bold"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="volunteerButton">PARTICIPAR</span>
                </v-btn>
              </template>
              <v-form ref="newContactForm" v-model="valid" lazy-validation>
                <v-card>
                  <v-toolbar color="primary" dark
                    >Formulário de Contato</v-toolbar
                  >
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col>
                          <v-text-field
                            v-model="form.name"
                            label="Nome completo*"
                            required
                            :rules="fullNameRules"
                          />
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="form.email"
                            label="Email*"
                            required
                            :rules="emailRules"
                          />
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="form.telephone"
                            v-mask="'(##) #####-####'"
                            label="Telefone"
                          />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select
                            v-model="form.subjectId"
                            :items="subjects"
                            label="Assunto"
                            required
                            :rules="topicRules"
                          />
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            v-model="form.message"
                            label="Mensagem*"
                            required
                            auto-grow
                            :rules="messageRules"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" text @click="dialog = false">
                      Fechar
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="sendEmail">
                      Enviar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

            <v-btn
              outlined
              rounded
              :x-large="
                $vuetify.breakpoint.lg ||
                $vuetify.breakpoint.md ||
                $vuetify.breakpoint.xl
              "
              color="primary"
              class="ml-5"
              to="/about"
            >
              <span class="volunteerButton">SAIBA MAIS</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col xs="12" sm="12" md="6" lg="6" xl="6" class="pa-10 pa-10">
        <v-card elevation="0" class="mx-auto" style="border-radius: 15px">
          <v-carousel
            cycle
            hide-delimiter-background
            show-arrows-on-hover
            delimiter-icon="mdi-minus"
            :height="
              $vuetify.breakpoint.lg ||
              $vuetify.breakpoint.md ||
              $vuetify.breakpoint.xl
                ? '60vh'
                : '40vh'
            "
            dark
          >
            <v-carousel-item
              v-for="(item, i) in items"
              :key="i"
              :src="item.src"
            />
          </v-carousel>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import {
  fullNameRules,
  emailRules,
  topicRules,
  messageRules,
} from '@/utils/Rules';
import { sendParticipationEmail } from '@/services/email';

export default {
  data() {
    return {
      fullNameRules,
      emailRules,
      topicRules,
      messageRules,
      valid: false,
      form: {
        name: '',
        email: '',
        subjectId: '',
        telephone: '',
        message: '',
      },
      dialog: false,
      subjects: [
        {
          text: 'Quero estudar',
          value: 1,
        },
        {
          text: 'Quero ser voluntário',
          value: 2,
        },
        {
          text: 'Outros',
          value: 3,
        },
      ],
      items: [
        {
          // eslint-disable-next-line global-require
          src: require('@/assets/img/slide1.jpg'),
        },
        {
          // eslint-disable-next-line global-require
          src: require('@/assets/img/slide2.jpg'),
        },
        {
          // eslint-disable-next-line global-require
          src: require('@/assets/img/slide3.jpg'),
        },
        {
          // eslint-disable-next-line global-require
          src: require('@/assets/img/slide4.jpeg'),
        },
      ],
    };
  },
  methods: {
    ...mapActions('loading', ['showLoading', 'hideLoading']),
    async sendEmail() {
      try {
        this.showLoading();
        const isValid = this.$refs.newContactForm.validate();
        if (isValid) {
          const { email, name, message, subjectId, telephone } = this.form;
          const subject = this.subjects[subjectId - 1].text || '';
          const { success } = await sendParticipationEmail(
            email,
            name,
            subject,
            message,
            telephone
          );

          if (success) {
            if (this.$root.vtoast) {
              this.$root.vtoast.show({
                message: 'E-mail enviado com sucesso!',
                top: true,
                right: true,
                show: true,
                color: 'success',
              });
            }
          } else {
            this.$root.vtoast.show({
              message:
                'Erro ao enviar e-mail. Por favor, tente novamente mais tarde.',
              top: true,
              right: true,
              show: true,
              color: 'error',
            });
          }
          this.dialog = false;
        }
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message:
              'Erro ao enviar e-mail. Por favor, tente novamente mais tarde.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
        this.dialog = false;
      } finally {
        this.hideLoading();
      }
    },
  },
};
</script>
